import * as React from 'react';
import Header from '@ui/scenes/Header';

interface Props {
  children: any;
  loggedIn: boolean;
}

const Content: React.FunctionComponent<Props> = ({ children, loggedIn }) => (
  <div className="main">
    {loggedIn && <Header />}
    <div className="main__container">{children}</div>
  </div>
);

export default Content;



// WEBPACK FOOTER //
// ./src/Main/components/Content/Content.tsx